'use client';

import Link from 'next/link';
import { Menu } from 'lucide-react';
import { Sheet, SheetContent, SheetTrigger, SheetClose } from '@/components/ui/sheet';
import { SITE_NAVIGATION } from '@/lib/site-navigation';
import { TvAppMenuSection } from '@/components/room/tv/TvAppMenuSection';
import { SubmitGameMenuSection } from '@/components/web-games/SubmitGameMenuSection';

export function VisitorSiteMenu({ onOpen, onNavigate }: { onOpen?: () => void; onNavigate?: (destination: typeof SITE_NAVIGATION[number]['id']) => void }) {
  return <Sheet onOpenChange={open => { if (open) onOpen?.(); }}>
    <SheetTrigger asChild><button type="button" aria-label="Open site menu" title="Site menu" className="grid h-10 w-10 place-items-center rounded-full text-fuchsia-400 hover:bg-white/10"><Menu size={25} /></button></SheetTrigger>
    <SheetContent
      side="left"
      title="Telegames"
      overlayClassName="bg-black/30"
      className="w-64 max-w-[calc(100vw-2rem)] overflow-y-auto border-white/15 p-5 text-white sm:max-w-[16rem] [&.Sheet-Background]:bg-[#050b22] [&>h2]:border-b [&>h2]:border-white/10 [&>h2]:pb-4 [&>h2]:pr-8 [&>h2]:text-base [&>h2]:text-white [&>button]:text-white"
    >
      <nav aria-label="Site navigation" className="mt-4 flex flex-col gap-1">{SITE_NAVIGATION.map(item => <SheetClose asChild key={item.href}><Link href={item.href} onClick={() => onNavigate?.(item.id)} className="flex min-h-11 items-center rounded-lg px-3 py-2 text-sm text-slate-100 hover:bg-white/10 focus-visible:outline-cyan-300">{item.label}</Link></SheetClose>)}</nav>
      <TvAppMenuSection />
      <SubmitGameMenuSection />
    </SheetContent>
  </Sheet>;
}
